module.exports = __webpack_public_path__ + "static/media/zip-icon.1cd1df37.svg";